import { Alert, Box, Link, Snackbar, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useState } from "react";
import { Link as RouterLink } from "react-router-dom";

import useCachedUserData from "@/hooks/useCachedUserData";
import AccountPopover from "@/layouts/dashboard/header/AccountPopover";
import NotificationsPopover from "@/layouts/dashboard/header/NotificationsPopover";

const RootStyle = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(1.5, 2),
    borderRadius: Number(theme.shape.borderRadius) * 1.5,
    backgroundColor: theme.palette.grey[500_12],
    transition: theme.transitions.create(["opacity", "width"], {
        duration: theme.transitions.duration.shorter,
    }),
}));

type NavbarAccountProps = {
    isCollapse?: boolean;
};

export default function NavbarAccount({ isCollapse = false }: NavbarAccountProps) {
    const { effectiveUserData } = useCachedUserData();

    const [snackbar, setSnackbar] = useState({
        open: false,
        message: "",
        severity: "success" as "success" | "error",
    });

    // Close snackbar
    const handleCloseSnackbar = () => {
        setSnackbar({ ...snackbar, open: false });
    };

    return (
        <>
            <Link underline="none" component={RouterLink} to="#">
                <RootStyle
                    sx={{
                        ...(isCollapse && {
                            bgcolor: "transparent",
                            width: "auto",
                        }),
                    }}
                >
                    <AccountPopover />
                    <Box
                        sx={{
                            ml: 1.5,
                            flex: 1,
                            transition: (theme) =>
                                theme.transitions.create("width", {
                                    duration: theme.transitions.duration.shorter,
                                }),
                            ...(isCollapse && {
                                ml: 0,
                                width: 0,
                                overflow: "hidden",
                            }),
                        }}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                width: "100%",
                            }}
                        >
                            <Typography variant="subtitle2" noWrap sx={{ color: "primary.main" }}>
                                {effectiveUserData?.name}
                            </Typography>

                            <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                                <NotificationsPopover />
                            </Box>
                        </Box>
                    </Box>
                </RootStyle>
                {isCollapse && (
                    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 1, mt: 1 }}>
                        <Typography variant="caption" noWrap sx={{ color: "primary.main" }}>
                            {effectiveUserData?.name}
                        </Typography>

                        <NotificationsPopover />
                    </Box>
                )}
            </Link>

            {/* Notification Snackbar */}
            <Snackbar
                open={snackbar.open}
                autoHideDuration={3000}
                onClose={handleCloseSnackbar}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            >
                <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: "100%" }}>
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </>
    );
}
